export const getFilterColSpan = (colSpan = 1): string => {
  const span = Math.max(1, Math.min(colSpan, 12));

  return [
    "sm:col-span-2",
    "md:col-span-3",
    "lg:col-span-2",
    `xl:col-span-${span}`,
    `2xl:col-span-${span}`,
  ].join(" ");
};